export default __webpack_public_path__ + "static/media/ic-crops-seed.5926e809.svg";